import 'babel-polyfill';
import $ from 'jquery';

import { ifExists } from './utils';

import appComponent from './components/appComponent';
import loginComponent from './components/loginComponent';

const app = new ifExists('#app');
app.exists((elements) => {
  new appComponent($(elements));
});

const login = new ifExists('#login');
login.exists((elements) => {
  new loginComponent($(elements));
});



// WEBPACK FOOTER //
// ./src/index.js